import { Component } from '@angular/core';
import { SeoService } from '@app/core/services/seo.service';

@Component({
    selector: 'ins-claims',
    templateUrl: './claims.component.html',
})
export class ClaimsComponent {
    // TODO: Meta data via routing module
    public pageTitle: any = this.seo.setTitle('Mijn verzekeringsmap - Mijn schades - InShared');

    constructor(
        private seo: SeoService,
    ) {}
}
